import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { api } from '@app/utils/api';
import { PANEl_BASE_URL } from '@app/contstants/endpoints';
import { ISelectOption } from '@widgets/multi-select';
import { ERR_BAD_REQUEST } from '@app/contstants/http-codes';
import { ServerError } from '@app/error/ServerError';

export const fetch = async ({
  managers,
  source,
  tag,
  clientId,
  terms,
  overrideName,
  outOfFlex,
  isNew,
}: {
  clientId: number;
  managers?: ISelectOption[] | null;
  source?: ISelectOption | null;
  tag?: ISelectOption | null;
  terms?: number | null;
  overrideName?: string | null;
  outOfFlex?: boolean | null;
  isNew?: boolean | null;
}): Promise<void> => {
  try {
    const data: {
      managers?: string[] | null;
      tags?: string | null;
      source?: string | null;
      terms?: number | null;
      override_name?: string | null;
      out_of_flex?: boolean | null;
      is_new?: boolean | null;
    } = {};

    if (managers !== undefined) {
      data['managers'] = managers ? managers.map(manager => manager.value) : null;
    }

    if (tag !== undefined) {
      data['tags'] = tag?.value;
    }

    if (terms !== undefined) {
      data['terms'] = terms;
    }

    if (overrideName !== undefined) {
      data['override_name'] = overrideName;
    }

    if (source !== undefined) {
      data['source'] = source?.value;
    }

    if (outOfFlex !== undefined) {
      data['out_of_flex'] = outOfFlex;
    }

    if (isNew !== undefined) {
      data['is_new'] = isNew;
    }

    await api.patch<{ id: string; name: string }>(
      `${PANEl_BASE_URL}/clients/clients/${clientId}/update_client/`,
      data
    );
  } catch (e: any) {
    if (e.status === ERR_BAD_REQUEST) {
      throw new ServerError(e.response.data.error);
    }
  }
};

export const useUpdateCustomer = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
